// Top-level paths that belong to SoapLab's own pages. Any other single-segment path is a
// member's public profile (soaplab.in/username), so the sidebar treats it as Community and
// usernames may not use these. App.routes.test.jsx checks this list covers every route.
export const RESERVED_PATHS = new Set([
  '', 'login', 'signup', 'verify-email', 'auth', 'profile', 'pricing', 'contact', 'help',
  'privacy', 'terms', 'refund-policy', 'shipping-policy', 'blog', 'community', 'feature-requests',
  'recipes', 'calculator', 'melt-and-pour', 'templates', 'dashboard', 'inventory', 'batches',
  'calendar', 'notifications', 'generator', 'print', 'sales', 'labels', 'backup', 'reports',
  'notes', 'quickbatch', 'admin', 'settings', 'lab', 'my-tickets',
]);
